import sdk from '@src/lib/sdk';
import { CurrentPostQuery } from '@src/generated/graphql';
import Post from '@components/Post';
import { PostProvider } from '@components/Post/PostContext';
import { ICategories } from '@components/Post/interfaces';
import {
  handlePostNavigation,
  IPostNavigation,
} from '@src/pageHelpers/blog/handlePostNavigation';
import { handleCategories } from '@src/pageHelpers/blog/handleCategories';
import CookieConsentWrapper from '@components/Shared/CookieConsentWrapper/CookieConsentWrapper';

const PostPage = ({
  data,
}: {
  data: {
    post: CurrentPostQuery['allPost'][number];
    categories: ICategories;
    postNavigation: IPostNavigation;
  };
}) => {
  if (!data) return <div>ERROR!</div>;

  return (
    <PostProvider value={data}>
      <CookieConsentWrapper>
        <Post />
      </CookieConsentWrapper>
    </PostProvider>
  );
};

export async function getStaticPaths() {
  const allPosts = await sdk.allPosts();
  return {
    paths:
      allPosts.allPost.map((post) => ({
        params: {
          slug: post.slug?.current,
        },
      })) || [],
    fallback: true,
  };
}

export async function getStaticProps({
  params,
  preview = false,
}: {
  params: { slug: string };
  preview: boolean;
}) {
  const currentPost = await sdk.currentPost({ slug: params.slug });
  const allPostsData = await sdk.allPosts();

  const categories = await handleCategories(allPostsData);
  const postNavigation = handlePostNavigation(allPostsData, params.slug);

  return {
    props: {
      preview,
      data: { post: currentPost.allPost[0], categories, postNavigation },
    },
  };
}

export default PostPage;
